import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CheckCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { Auth } from "aws-amplify";

const sendSession = async () => {
  try {
    // Retrieve the current session
    const session = await Auth.currentSession();

    const accessToken = session.getAccessToken().getJwtToken();
    let refreshToken = session.getRefreshToken().getToken()
    sendTokensToExtension(accessToken,refreshToken)

    // Now, make the API call to get the user's profile
   
  } catch (error) {
    console.error("Error retrieving session after redirect:", error);
  }
};
const sendTokensToExtension =(accessToken, refreshToken) =>{
  // Note: Using window.location.origin for security. Extension should verify origin.
  // For browser extensions, consider using chrome.runtime.sendMessage instead of postMessage.
  window.postMessage({
    action: "sendTokens",
    accessToken: accessToken,
    refreshToken: refreshToken,
    source: "datarate-web",
    timestamp: Date.now()
  }, window.location.origin);
}
const ExtensionLoginSuccess = () => {
  const token = useSelector((state) => state.token);

  useEffect(() => {
    localStorage.removeItem('is_extension_login');
    localStorage.removeItem('redirectAfterLogin');
    // Send tokens to extension after successful login
    sendSession()
    
    // Prevent body scroll on this page
    document.body.style.overflow = 'hidden';
    
    return () => {
      // Restore body scroll when component unmounts
      document.body.style.overflow = '';
    };
  }, []);

 
  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
        textAlign: 'center',
        color: 'success.main',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%'
      }}
    >
      <CheckCircle style={{ fontSize: 60 }} />
      <Typography variant="h4" gutterBottom>
        Login Successful!
      </Typography>
      <Typography variant="body1">
        You can now use the Datarate extension.
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Please note: Sometimes, a page refresh is required to activate the extension.
      </Typography>
    </Box>
  );
};

export default ExtensionLoginSuccess;
